import { useRouter } from '@/util/hook/custom';
import useDispatch from '@/util/hook/useDispatch';
import useEffect from '@/util/hook/useEffect';
import useSelector from '@/util/hook/useSelector';
import useState from '@/util/hook/useState';
import { historyFromPathUpdate, selectFromPath } from '@/util/redux/history';
export const useTrackBrowserHistory = () => {
    const [fromPage, setFromPage] = useState(null);
    const _fromPage = useSelector(selectFromPath);
    const { useLocation } = useRouter();
    const location = useLocation();
    const currentPage = location.pathname;
    const dispatch = useDispatch();
    // #NOTES
    /**
     * We return the useState value instead of the redux state
     * to make sure that the client of this hook can get the exact fromPage value
     * but not the already updated one, since we update the redux state right after
     * the user is redirected to the current page.
     *
     * The drawback is the inconsistency between the redux state and the useState value.
     *
     * A better solution is to update the redux state before the user is redirected to the next page
     * but currently we don't have a good way to do that.
     *
     * notes: navigate options (React Router) does not fit our case because we need to handle
     * all the navigation behavior but not just the one triggered by the navigate function.
     */
    useEffect(() => {
        if (fromPage === null) {
            setFromPage(_fromPage);
        }
        dispatch(historyFromPathUpdate(currentPage));
    }, []);
    return { fromPage };
};
